module.exports = __webpack_public_path__ + "img/level2addon_idle_gun_mask.99029843.png";